import Link from "next/link";
import Product from "@components/ProductCard/Product";
import styles from "./styles/NoOrders.module.css";

const MENS = "mens";
const WOMENS = "womens";
const HOME = "home";

const NavLink = ({ title, slug }) => {
  return (
    <li className={styles.navListItem}>
      <Link
        href={{
          pathname: "/collections/[slug]",
          query: { slug: `${slug}` },
        }}
      >
        <a className={styles.navLink}>{title}</a>
      </Link>
    </li>
  );
};

const Nav = () => {
  return (
    <nav className={styles.nav}>
      <ul className={styles.navList}>
        <NavLink title="Shop Menswear" slug={MENS} />
        <NavLink title="Shop Womenswear" slug={WOMENS} />
        <NavLink title="Shop Home" slug={HOME} />
      </ul>
    </nav>
  );
};

const Title = () => {
  return <p className={styles.title}>Suggested for you</p>;
};

const ProductCards = ({ products, collection }) => {
  return (
    <section className={styles.products}>
      {products?.map((product, index) => {
        return (
          <Product
            key={product.id}
            product={product}
            collection={collection}
            listPosition={index}
          />
        );
      })}
    </section>
  );
};

export const NoOrders = ({ products }) => {
  return (
    <section className={styles.container}>
      <Nav />
      <Title />
      <section className={styles.productsContainer}>
        <ProductCards products={products.mens} collection={MENS} />
        <ProductCards products={products.womens} collection={WOMENS} />
        <ProductCards products={products.home} collection={HOME} />
      </section>
    </section>
  );
};
